import http from '@/communication/AuthConnection'

export default async ({ commit }, params) => {
  try {
    const request = await http.get('/v1/report/bid-resume', { params })
    return request.data
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/brain/report/bid-resume/index.js